var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ViewComponent } from '../view/view.component';
import { QuestionnaireService } from './questionnaire.service';
var QuestionnaireAggregateComponent = /** @class */ (function (_super) {
    __extends(QuestionnaireAggregateComponent, _super);
    function QuestionnaireAggregateComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.resultData = [];
        return _this;
    }
    QuestionnaireAggregateComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.cols = [];
        this.rec = {};
        this.dispRec = {};
    };
    /**
     * テンプレートの描画処理の最後に集計結果チャートを表示する
     */
    QuestionnaireAggregateComponent.prototype.showChart = function () {
        var i = 0;
        for (var d in this.resultData) {
            var result = this.resultData[i];
            if (result.chart != null) {
                var index = result.qFormM.q_no;
                var ctx = document.getElementById('q_result_chart_' + index);
                this.myChart = new Chart(ctx, result.chart);
            }
            i++;
        }
        this.execShowChart = false;
    };
    QuestionnaireAggregateComponent.prototype.onSubscribe = function (data) {
        this.questionnaireTitle = data.questionnaireTitle;
        this.answerNum = data.answerNum;
        if (data.resultList !== 'undefined' && data.resultList instanceof Array) {
            this.resultData = data.resultList;
        }
        // グラフ描画処理コール用
        this.execShowChart = true;
    };
    QuestionnaireAggregateComponent.prototype.onEvent = function (e1, e2, index) {
    };
    QuestionnaireAggregateComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'questionnaire-aggregate',
                    template: "<form class=\"form\" id=\"{{ componentName }}\">\n  <div class=\"-mb-3\">\n    <ul>\n      <li class=\"formLabelText form_dt\">\n        {{ (msg | async)['au.COMPONENT.QuestionnaireAggregateComponent.label.questionnaire_title'] }}\n      </li>\n      <li class=\"form_li\">\n        <pre class=\"formReadOnly\">{{questionnaireTitle}}</pre>\n      </li>\n    </ul>\n  </div>\n  <div class=\"-mb-2\">\n    <ul>\n      <li class=\"formLabelText form_dt\">\n        {{ (msg | async)['au.COMPONENT.QuestionnaireAggregateComponent.label.answer_num'] }}\n      </li>\n      <li class=\"form_li\">\n        <pre class=\"formReadOnly\">{{answerNum}}</pre>\n      </li>\n    </ul>\n  </div>\n\n  <horizontal-rule></horizontal-rule>\n  <dl class=\"formLabelText -mt-1\">{{ (msg | async)['au.COMPONENT.QuestionnaireAggregateComponent.label.aggregate_result'] }}</dl>\n  <div class=\"-mb-2\">{{ (msg | async)['au.COMPONENT.QuestionnaireAggregateComponent.label.note'] }}</div>\n\n  <ng-template ngFor let-result [ngForOf]=\"resultData\">\n    <div class=\"formLabelText\" *ngIf=\"result.qFormM.q_no != null\">\n      Q.{{result.qFormM.q_no}} {{result.qFormM.name}}\n    </div>\n    <div *ngIf=\"result.qFormM.form_type == 'image'\">\n      <img src=\"{{result.qFormM.image_path}}\">\n    </div>\n    <div *ngIf=\"result.qFormM.form_type == 'title'\">\n      <p class=\"formLabel\">{{result.qFormM.name}}</p>\n    </div>\n    <div class=\"-mt-1\">\n      <p class=\"formLabel\">{{result.qFormM.description}}</p>\n    </div>\n    <div *ngIf=\"result.chart != null\" style=\"position: relative;\">\n      <canvas id=\"q_result_chart_{{result.qFormM.q_no}}\" height=\"100\"></canvas>\n    </div>\n    <div class=\"-mt-1\" *ngIf=\"result.answerList != null\">\n      <ng-template ngFor let-answer [ngForOf]=\"result.answerList\">\n        <ul>\n          <li class=\"form_li\">\n            <pre class=\"formReadOnly\">{{answer}}</pre>\n          </li>\n        </ul>\n      </ng-template>\n    </div>\n    <div class=\"formLabelText -mt-1\" *ngIf=\"result.qFormM.q_no != null && result.qFormM.questionnaireFormU.length == 0\">\n      \u56DE\u7B54\u30C7\u30FC\u30BF\u306A\u3057\n    </div>\n    <div *ngIf=\"result.qFormM.form_type != 'paging'\">\n      <p class=\"-mt-3\"></p>\n    </div>\n  </ng-template>\n</form>\n<span *ngIf=\"execShowChart == true\">{{showChart()}}</span>\n"
                }] }
    ];
    /** @nocollapse */
    QuestionnaireAggregateComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: QuestionnaireService }
    ]; };
    return QuestionnaireAggregateComponent;
}(ViewComponent));
export { QuestionnaireAggregateComponent };
//# sourceMappingURL=questionnaire-aggregate.component.js.map